import { useIvDiscoveryStore } from './discovery'
import { useIvPatientSummaryStore } from './patientSummary'
import { useIvProviderStore } from './provider'
import { useIvRecoveryStore } from './recovery'
import { useIvVerificationStore } from './verification'

/**
 * Drops patient and staff data held by the insurance stores.
 *
 * Pinia setup stores are singletons for the life of the page and logout is a SPA route change (no
 * reload), so without this the previous user's verification/discovery history, patient summary and
 * provider staff list stay in memory for whoever signs in next in the same tab.
 */
export function resetInsuranceStoresOnLogout() {
  useIvVerificationStore().resetForLogout()
  useIvDiscoveryStore().resetForLogout()
  useIvPatientSummaryStore().reset()
  useIvProviderStore().reset()
  useIvRecoveryStore().reset()
}
